import { CondimentInterface } from "../entities/Condiment";

export const keepSelectedCondiments = (
  condiments: CondimentInterface[],
  selectedCondiments: CondimentInterface[],
): CondimentInterface[] => {
  selectedCondiments.forEach((item) => {
    const index = condiments.findIndex((condiment) => condiment.id === item.id);
    if (index !== -1) {
      condiments[index].meta.selected = true;
    }
  });
  return condiments;
};
